import { useEffect, useRef } from 'react';

export const useIntersectionObserver = (callback, deps = []) => {
  const ref = useRef(null);
  const intersectionObserver = useRef(null);

  useEffect(() => {
    if (!window.IntersectionObserver || !ref?.current) return undefined;
    const node = ref.current;

    function unobserve() {
      if (node) {
        // eslint-disable-next-line no-unused-expressions
        intersectionObserver.current?.unobserve(node);
      }
    }

    function handleEntries([entry]) {
      if (entry.isIntersecting) {
        callback();
        unobserve();
      }
    }

    intersectionObserver.current = new IntersectionObserver(handleEntries, {
      threshold: 0.1
    });
    intersectionObserver.current.observe(node);

    return unobserve;
  }, [callback, ...deps]);

  return ref;
};
